import React from "react";
import "../../css/sharedStyles.css";

var FooterContainer = class FooterContainer extends React.Component{
    render() {
      const inlineStyle = {
        textAlign:"center",
        fontSize:"14px",
        padding:"4px 0",
        width:"100%",
        float:"left",
        marginTop:"10px"
      }
      return (
        <div className="content_box_square" style={inlineStyle}>© 2017 MARVEL | Data provided by Marvel. © 2017 MARVEL</div>
      );
    }
  }

  export default FooterContainer;


// WEBPACK FOOTER //
// ./src/components/footer/FooterContainer.js